import React, { memo } from 'react';
import { mutationTypes } from './mutationUtils';
import { lowercaseSoftIncompleteMutations } from './softMutations';
import ExplanationMutation from './ExplanationMutation';
import ExplanationSubTitle from './ExplanationSubTitle';
import TableForListSubItem from './TableForListSubItem';
import ListParagraphForExceptions from './ListParagraphForExceptions';

const ExplanationNoun_FS_MP_NounMutation = () => {
  return (
    <ExplanationMutation lowercaseMutations={lowercaseSoftIncompleteMutations} mutationType={mutationTypes.SOFT_INCOMPLETE}>
      <>
        <ExplanationSubTitle>
          Feminine Singular
        </ExplanationSubTitle>
        <TableForListSubItem
          className={'bolden-first-letter'}
          pairs={[
            [ 'kador', 'ar gador' ],
            [ 'kambr', 'ar gambr' ],
            [ 'koumoulenn', 'ur goumoulenn' ],
            [ 'paner', 'ar baner' ],
            [ 'plasenn', 'ar blasenn' ],
          ]}
        />
        <ListParagraphForExceptions>
          plac'h -> ur plac'h <br />
          (ur plac'h vat, ur plac'h vrav, ar plac'h koant)
        </ListParagraphForExceptions>
        <TableForListSubItem
          className={'bolden-first-letter'}
          pairs={[
            [ 'taol', 'an daol' ],
            [ 'gar (cuisse)', 'ar c\'har' ],
            [ 'godell', 'ar c\'hodell' ],
          ]}
        />
        <ListParagraphForExceptions>
          gar (gare) -> ur gar <br />
          greg -> ur greg
        </ListParagraphForExceptions>
        <TableForListSubItem
          className={'bolden-first-letter'}
          pairs={[
            [ 'gwastell', 'ar wastell' ],
            [ 'gwech', 'ur wech' ],
            [ 'gwerenn', 'ar werenn' ],
            [ 'gwreg', 'ar wreg' ],
            [ 'balafenn', 'ar valafenn' ],
            [ 'boest', 'ar voest' ],
            [ 'mamm', 'ar vamm' ],
            [ 'maouez', 'ar vaouez' ],
            [ 'merc\'h', 'ar verc\'h' ],
          ]}
        />
        <ExplanationSubTitle>Masculine Plural of Persons, except -où</ExplanationSubTitle>
        <TableForListSubItem
          className={'bolden-first-letter'}
          pairs={[
            [ 'kelennerien', 'ar gelennerien' ],
            [ 'paotr', 'ar baotred' ],
            [ 'tud', 'an dud' ],
          ]}
        />
        <ListParagraphForExceptions>
          tadoù -> an tadoù<br />
        </ListParagraphForExceptions>
        <TableForListSubItem
          className={'bolden-first-letter'}
          pairs={[
            [ 'Gallaoued', 'ar C\'hallaoued' ],
            [ 'Gallegerien', 'ar C\'hallegerien' ],
            [ 'Gwenediz', 'ar Wenediz' ],
            [ 'baleerien', 'ar valeerien' ],
            [ 'bugale', 'ar vugale' ],
            [ 'mibien', 'ar vibien' ],
            [ 'mistri', 'ar vistri' ],
          ]}
        />
      </>
    </ExplanationMutation>
  );
};

export default memo(ExplanationNoun_FS_MP_NounMutation);
